import { UserCertificate } from '@/client/types/content/UserCertificate';
import { useAuthStore } from '@/client/services/state/authStore';
import { useConfigStore } from '@/client/services/state/configStore';
import { usePartnerStore } from '@/client/services/state/partnerStore';

export const useParseCertificateData = (certificate: UserCertificate) => {
  const { config } = useConfigStore();
  const { authConfig } = useAuthStore();
  const { company, user } = authConfig;
  const { metadata: userMetadata } = user;
  const { partner } = usePartnerStore();

  const { certificateData, completedDate, metadata: contentMetadata } = certificate;

  let url = '';

  if (authConfig?.user?.partner?.branding?.logo_url) {
    url = authConfig?.user?.partner?.branding?.logo_url;
  } else if (partner?.branding?.logo_url) {
    url = partner?.branding?.logo_url;
  } else {
    url = `${config.publicImageUrl}${config.layout}/logos/logo.${config.theme.logo_format}`;
  }

  const certificateDataMap = certificateData.reduce((acc, { name, value }) => {
    acc[name] = value;
    return acc;
  }, {} as Record<string, string>);

  const displayTitle = certificateDataMap.alt_title || certificate.title;

  // Keep this .toString() in case there's any booleans in the database for this value.
  const hideDate = certificateDataMap.hide_completion?.toString() === 'true';

  const logoHeight = config.theme.logo_format === 'svg' ? '32px' : 'auto';

  const filteredUserMetadata: Record<string, any> = {};

  company.user_metadata_fields.forEach((umf) => {
    if (umf.visibility.certificates === 'readonly') {
      filteredUserMetadata[umf.name] = userMetadata?.[umf.name];
    }
  });

  return {
    url,
    displayTitle,
    hideDate,
    completedDate,
    logoHeight,
    userMetadata,
    filteredUserMetadata,
    contentMetadata,
  };
};
